module.exports = __webpack_public_path__ + "img/web.03089b19.webp";